<editor
    class="basic-tinymce-editor-ele"
    *ngIf="tinyLoaded"
    [init]="editorInit"
    [disabled]="disabled"
    [initialValue]="body"
></editor>
